import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MailService } from '../../../services/mail.service';
import { switchMap, withLatestFrom, map, catchError, tap } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import { MailModuleActions } from '../actions/mail-module.action';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';

@Injectable()
export class MailModuleEffects {
  constructor(private actions$: Actions<MailModuleActions>,
              private store$: Store<fromStore.State>,
              private mailModuleService: MailService,
            ) {}

  ReadMailModuleList$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(featureActions.MailModuleActionTypes.GetMailModuleList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const params = { ...action.payload, otp: user.otp };
      return this.mailModuleService.ReadMailModule(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpsertMailModuleList(res.msg.body)];
          } else {
            return of(new featureActions.GetMailModuleListFail());
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetMailModuleListFail());
        })
      );
    })
  ));

  AddMailModule$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(featureActions.MailModuleActionTypes.AddMailModule),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.AddMailModule
      };
      const param = { ...action.payload, otp: user.otp };
      return this.mailModuleService.AddMailModule(param).pipe(
        switchMap((res: any) => {
          if (res.Flag) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.Flag, msg: 'Add Mail Module Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Add Mail Module Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));

  UpdateMailModule$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(featureActions.MailModuleActionTypes.UpdateMailModule),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateMailModule
      };
      const param = { ...action.payload, otp: user.otp };
      return this.mailModuleService.UpdateMailModule(param).pipe(
        switchMap((res: any) => {
          if (res.Flag) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.Flag, msg: 'Update Mail Module Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Update Mail Module Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));

  DeleteMailModule$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(featureActions.MailModuleActionTypes.DeleteMailModule),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.DeleteMailModule
      };
      const param = { ...action.payload, otp: user.otp };
      return this.mailModuleService.DeleteMailModule(param).pipe(
        switchMap((res: any) => {
          if (res.Flag) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.Flag, msg: 'Delete Mail Module Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Delete Mail Module Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
}
